import { Model, RailsFormat } from "./model";
import { TicketAllocation } from "./ticket-allocation";
import { Contact } from "./contact";
import { CreditCard } from "./credit-card";

export class Event extends Model implements RailsFormat {

  constructor(
    public id?: number,
    public title: string = null,
    public description: string = null,
    public startDateTime: Date = null,
    public endDateTime: Date = null,

    public ticketAllocations: TicketAllocation[] = [],

    public createdAt: Date = null,
    public updatedAt: Date = null,
  ) { super(); }

  static clone(obj: any) {
    const e = new this();

    if (obj.id) { e.id = obj.id }
    if (obj.title) { e.title = obj.title }
    if (obj.description) { e.description = obj.description }
    if (obj.startDateTime) { e.startDateTime = new Date(obj.startDateTime) }
    if (obj.endDateTime) { e.endDateTime = new Date(obj.endDateTime) }

    if (obj.ticketAllocations && obj.ticketAllocations.length > 0) {
      obj.ticketAllocations.forEach((ta: any) => {
        e.ticketAllocations.push(TicketAllocation.clone(ta))
      })
    }

    if (obj.createdAt) { e.createdAt = new Date(obj.createdAt) }
    if (obj.updatedAt) { e.updatedAt = new Date(obj.updatedAt) }

    return e;
  }

  serializeForRails() {
    const response: any = Object.assign({}, this)

    if (this.id === 0) { response.id = null }

    response.ticketAllocationsAttributes = response.ticketAllocations

    return response
  }

  static createPurchaseTicketAsGuestPayload(student: Contact, parent: Contact, taIds: number[], creditCard: CreditCard): any {
    const result: any = {}

    result.student_attributes = student.serializeForRails()
    result.guardian_attributes = parent.serializeForRails()
    result.card_attributes = creditCard.serializeForRails()
    result.tickets_attributes = taIds.map((ticketAllocationId) => {
      return {
        ticket_allocation_id: ticketAllocationId,
       }
    });

    return result
  }

  static createPurchaseTicketAsExistingPayload(student: Contact, taIds: number[]): any {

    const result: any = {}

    result.studentId = student.id
    result.ticketAllocationIds = taIds

    return result
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/event.ts